module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAECSURBVEhL7dQ7TgJRAIXhoSexANGCBRhi4xKoMHbswxXYUEAoMe7BxtCRaO8WfFFYWRkeFSRS6v8jk9wQqrnXSk7yZYYpzhkYMtk+pIQbTDHCIZLmHN+BJyQd6cLia1ju+RDJ8gBL2xhszj+QJP4Uc1ga6iM6lj/Dwhnu0UMT0anhBZY7kvShWv4Kyx1JWn6EsNyxZLH8DZY7ElV+gLPf03WOkZd7dKxw6niHZVdeIJdIXq5PVGAc8ZsUjne2XX4CU90co3KHvFy+xIwjjnXWnyKyRDjQQAuW59dOUThfCAe2jVFG4fg+2VUsy6MesHnEn5WbCzgywQoL3CL/m/7LZNkPGxxdy0V76FQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-spade/dark/24.png
// module id = 2452
// module chunks = 2